var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource',{staticClass:"flex-grow-1",attrs:{"resource":"moderator","resourceName":"Moderator","original":_vm.moderator,"attributes":_vm.attributes}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Moderator bearbeiten")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }